module.exports = __webpack_public_path__ + "a17d279f/img/search-filter-icon.c4751a52.svg";